import { useQuery } from 'react-query';
import RestHttpClient from '../../../common/RestHttpClient';
import { ExpiredDealState } from '../../../generated/ApiClient';

export const dashboardExpiredDealsQueryKey = (state: ExpiredDealState, showAll: boolean) =>
  ['dashboard', 'expiredDeals', state, showAll] as const;

export function useExpiredDealsQuery(state: ExpiredDealState, showAll: boolean) {
  return useQuery({
    queryKey: dashboardExpiredDealsQueryKey(state, showAll),
    queryFn: async () => {
      const { data } = await RestHttpClient.getExpiredDeals(state, showAll);
      return data;
    },
    keepPreviousData: true,
    staleTime: 60_000,
  });
}
